module.exports = __webpack_public_path__ + "dd02ab3c5d4f8959b90247cd2dde131b.fbx";